import { createContext } from 'react';

interface TabsContextProps {
  addOnTabChangeListener?: (listener: () => void) => void;
  removeOnTabChangeListener?: (listener: () => void) => void;
}

export const TabsContext = createContext<TabsContextProps>({});
